
// import axios from 'axios'
// import request from '../services/request.service'
import store from '../stores'
// import message from 'resources/data/message/message.en'

export async function getClientMessage(key) {
    // return await axios.get('static/data/message.en.json').then(response => response.data[key])
    const locale = store.getState().navigate.getIn(['language', 'selected'])
    const message = require('../resources/data/message/message.'+locale)
    return message[key]
}

export async function getServerMessage(key) {
    //  const locale = store.getState().navigate.getIn(['language', 'selected'])
    // try {
    //     const response = await request.get(`/lang/${locale}.json`).then(response => response.data[key])
    //     console.log(response)
    //     if (!response) return key;
    //     return response
    // } catch (e) {
       
    // }
    // return  getClientMessage('error.network.connect').then(msg => alert(msg))
    return key;
}

